<div class="card overflow-auto flex flex-col md:flex-row sm:mr-6">
  <div class="bg-primary/10 p-gutter flex-auto max-w-[300px]">
    <h2 class="headline mb-4 text-primary">{{'Quick access menu' | translate}}</h2>

    <p class="caption">{{'Quick access menu offers you accessing some last added links or pages that you marked as added to quick access menu from the side menu navigation.' | translate}}</p>

    <p class="caption">{{'you can keep them all, remove one and also you can remove them all.' | translate}}</p>

  </div>

  <div class="p-gutter flex-auto max-w-[400px]">
    <div class="d-flex justify-content-between">
<!--      <h3 class="body-2 m-0">{{'Features' | translate}}</h3>-->
      <button mat-button type="button" (click)="removeAll()">{{'Remove all' | translate}}</button>
    </div>

    <div class="mt-4 grid grid-cols-3">
      <a *ngFor="let feature of features"
         class="text-dark p-3 text-center mx-3 quick-access-item position-relative hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline">
        <mat-icon svgIcon="mat:delete" tooltip="{{'remove' | translate}}" (click)="remove(feature)" class="icon-sm position-absolute remove-icon" color="primary"></mat-icon>
        <mat-icon [routerLink]="feature.route" [svgIcon]="feature.icon" class="icon-xl" color="primary"></mat-icon>
        <div [routerLink]="feature.route" class="body-2 mt-2">{{ feature.label | translate }}</div>
      </a>
    </div>
  </div>

<!--  <div class="p-gutter flex-auto max-w-[350px]">-->
<!--    <h3 class="body-2 m-0">Pages</h3>-->

<!--    <div class="mt-6 grid grid-cols-2 gap-x-12 gap-y-4">-->
<!--      <a (click)="close()"-->
<!--         *ngFor="let page of pages"-->
<!--         [routerLink]="page.route"-->
<!--         class="text-dark body-1 no-underline hover:text-primary trans-ease-out">{{ page.label }}</a>-->
<!--    </div>-->
<!--  </div>-->
</div>

